/* eslint-disable indent */
/* eslint-disable max-lines-per-function */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import './cadastrar.css';
import { useHistory } from 'react-router-dom';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputMask } from 'primereact/inputmask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import Itau from '../../assets/itau.png';
import BancoBrasil from '../../assets/banco-do-brasil.png';
import Bradesco from '../../assets/bradesco.png';

import {
    faAddressBook,
    faPhone,
    faMobile,
    faMale,
    faFemale,
    faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage, Formik, Form as FormFormik, Field } from 'formik';
import * as yup from 'yup';
import * as moment from 'moment';
import { Message } from 'primereact/message';

import { validarCpfSemMascara } from '../../modulos/validation/cpf';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { BuscarCep } from '../../modulos/Cep';
import { InserirAssociado } from '../../services/contratoApi/index';
import {
    BuscarProduto,
    BuscarLocalidade,
    getProducts,
    BuscarProdutoBonificaco
} from '../../services/produtos/index';
import { BuscarCidadeIbge } from '../../services/Endereco/ibge';
import { ptBR } from '../../modulos/schemaDate';
import api from '../../services/backAxios/index';
import {
    itemsDocumento,
    opMensalidadePrime,
    opMensalidade,
    opTipoVenda,
    opSexo,
    opCarencia,
    opPromocional,
    opCidadesZPETNExterno
} from './opcoesDropdown';
import PopupCpf from './popupCpf/index';
import { showMessageAlert } from '../others/toastr';
import { DialogCopiarDadosContrato } from '../dialogs/dialogCopiarDadosContrato';
import { DialogErroBlacklistCadastrar } from '../dialogs/dialog-erro-blacklist';
import {
    criptObjectOnLocalStorage,
    decriptObjectOnLocalStorage,
    decriptoLocalStorage
} from '../../modulos/cripotografia/criptoStorage';
import { montarMsgAmigavel } from './helpers/msgAmigavelErros';
import { buscaNomeCemiterio } from './helpers/buscaNomeCemiterio';
import {
    condicaoPlanotipoMensalidade,
    condicaoPlanotipoMensalidadeM65
} from './helpers/condicaoPlanotipoMensalidade';
import { mascaraCpf } from '../../modulos/mascaraCpf';
import mailingService from '../../services/mailing/mailingService';
import auxQueryParamsRotaMailing from '../../modulos/function/auxQueryParamsRotaMailing';
import apiZelo from '../../services/backAxiosVendaToken';
import { Growl } from 'primereact/growl';
import validations from './helpers/cadastroContratoYupValidation';
import TipoCobranca from './TipoCobranca.jsx';
import { SalvarValorDinamicoAssoc } from '../../services/associados';
import { InputNumber } from 'primereact/inputnumber';

const CadastrarContratos = () => {
    const history = useHistory();
    const [subGrupos, setSubGrupos] = useState([]);
    const [buscaCep, setBuscaCep] = useState(false);
    const [Bairro, setBairro] = useState([]);
    const [Residencia, setResidencia] = useState([]);
    const [CepDigitado, setCepDigitado] = useState([]);
    const [Cidade, setCidade] = useState([]);
    const [Localidade, setLocalidade] = useState([]);
    const [Estado, setEstado] = useState([]);
    const [Coordenador, setCoordenador] = useState(
        decriptoLocalStorage('codCoordenador')?.decriptoValue
    );
    const [Supervisor, setSupervisor] = useState(
        decriptoLocalStorage('codSupervisor')?.decriptoValue
    );
    const [loading, setLoading] = useState('nada');
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [submit, setSubmit] = useState(true);
    const [erro, setErro] = useState(false);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [cpfCadastrado, setCpfCadastrado] = useState('');
    const [valorCpf, setValorCpf] = useState('');
    const [valorCpfAnterior, setValorCpfAnterior] = useState('');
    const [valorNome, setValorNome] = useState('');
    const [valorNomeAnterior, setValorNomeAnterior] = useState('');
    const [filialVendedor, setFilialVendedor] = useState([]);
    const [filialDropdow, setFilialDropdow] = useState([]);
    const [objFinal, setobjFinal] = useState([]);
    const [importLastContract, setImportLastContract] = useState(false);
    const [lastContract, setLastContract] = useState();
    const [nascimento, setNascimento] = useState('');

    const [mensagem, setMensagem] = useState([]);
    const [valido] = useState(true);

    const [GrupoAlocation, setGrupoAlocation] = useState([]);
    const [idLocation, setIdLocation] = useState(null);
    const [blockInput, setBlockInput] = useState(false);
    const [cepInvalido, setCepInvalido] = useState(false);
    const [nomeCemiterio, setNomeCemiterio] = useState([]);
    const [tipoVenda, setTipoVenda] = useState('');

    const Data = moment(new Date()).add(3, 'hours').format('DD-MM-YYYY');
    const DiaVenc = moment(new Date()).add(3, 'hours').format('DD');

    const [codeIbge, setCodeIbge] = useState('');
    const [ufLocation, setUfLocation] = useState('');
    const [grupoRegiao, setGrupoRegiao] = useState([]);
    const [planoRegiao, setPlanoRegiao] = useState([]);
    const [modalCopiarDadosContrato, setModalCopiarDadosContrato] = useState(false);
    const [dialogBlacklist, setDialogBlacklist] = useState(false);
    const [subGruposComDescontoBoleto, setSubGruposComDescontoBoleto] = useState([{}]);
    const [subGruposComDescontoCartao, setSubGruposComDescontoCartao] = useState([{}]);
    const [subGruposComDescontoEscelsa, setSubGruposComDescontoEscelsa] = useState([
        {}
    ]);
    const [subgrupoSelecionado, setSubgrupoSelecionado] = useState();
    const [msgPlanosParaBonificar, setMsgPlanosParaBonificar] = useState();
    const [isTipoCobrancaSelecionado, setTipoCobrancaSelecionado] = useState();

    const NomeVendedor = decriptoLocalStorage('Nome')?.decriptoValue;
    const Vendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const NomeSupervisor = decriptoLocalStorage('NomeSupervisor')?.decriptoValue;
    const NomeCoordenador = decriptoLocalStorage('NomeCoordenador')?.decriptoValue;
    const area = decriptoLocalStorage('area')?.decriptoValue;
    const growl = useRef(null);

    async function carregaDadosVendedor() {
        setLoading('nada');

        const [response] = await Promise.all([BuscarLocalidade(), BuscarProdutos()]);
        const filiaisOrdenadas = response.sort((a, b) =>
            a.filial.localeCompare(b.filial)
        );
        const dataFilial = await filiaisOrdenadas.map(item => item.filial);

        setFilialDropdow(dataFilial);
        setFilialVendedor(response);

        const codSupervisor = decriptoLocalStorage('codSupervisor')?.decriptoValue;
        const codCoordenador = decriptoLocalStorage('codCoordenador')?.decriptoValue;
        const escritorio = decriptObjectOnLocalStorage('escritorio');
        const idLocalidade = decriptObjectOnLocalStorage('idLocalidade');

        setGrupoAlocation([escritorio]);
        setSupervisor(codSupervisor);
        setCoordenador(codCoordenador);
        setIdLocation(idLocalidade);

        if (area == '2') {
            setBlockInput(true);
        }

        setLoading('loading');
        setSubmit(false);
    }

    useEffect(() => {
        try {
            carregaDadosVendedor();
        } catch (error) {
            setErro(true);
            setMensagem('Ops! Algo deu errado, tente novamente!');
            setLoading('loading');
            throw new Error(erro);
        }
    }, [Vendedor]);

    const checarCelular = async e => {
        const celular = e.target.value.toString();
        const celularFormatado = celular.replace(/ |-|\(|\)/gi, '');

        if (`${Number(celularFormatado)}`.length === 11) {
            const response = await apiZelo.get(`lista-negra/${celularFormatado}`);

            const arrayInscricoes = response.data?.inscricoes?.split(';');

            if (arrayInscricoes?.length >= 3) {
                setDialogBlacklist(true);
            }
        }
    };

    const BuscarProdutos = async () => {
        try {
            await BuscarProduto().then(response => {
                if (response) {
                    response.forEach(element => {
                        element.label = element.descricao;
                        element.value = element.SubGrupo;
                    });
                    setSubGrupos(response);
                }
            });
        } catch (error) {
            return error;
        }
    };

    const handleNascimento = event => {
        const anoEmMilissegundos = 31556952000;

        setNascimento((new Date() - new Date(event.target.value)) / anoEmMilissegundos);
    };

    const CEP = async (cep, tipo) => {
        try {
            setLoadingProducts(true);

            if (tipo === 1) {
                if (cep.length > 1) {
                    await BuscarCep(cep)
                        .then(response => {
                            const { erro, ibge, uf, localidade, bairro, logradouro } =
                                response;

                            if (erro) {
                                showMessageAlert(
                                    'CEP inválido!',
                                    'Insira o cep correto!'
                                );
                                setCepInvalido(true);
                            } else {
                                setCodeIbge(ibge);
                                setUfLocation(uf);

                                setCepDigitado(cep.replace(/\D/g, ''));

                                BuscarCodIbge(ibge);
                                setBairro(
                                    bairro.length > 1 ? bairro.toUpperCase() : Bairro
                                );
                                setResidencia(
                                    logradouro.length > 1 ?
                                        logradouro.toUpperCase() :
                                        Residencia
                                );
                                setLocalidade(
                                    localidade.length > 1 ?
                                        localidade.toUpperCase() :
                                        ''
                                );
                                setEstado(uf);
                                setBuscaCep(false);
                            }
                        })
                        .catch(_erro => {
                            setBuscaCep(false);
                            setCepDigitado(cep);
                        });
                }
            } else if (tipo === 2) {
                if (cep.length > 1) {
                    await BuscarCep(cep)
                        .then(response => {
                            const { erro, ibge, uf, localidade, bairro, logradouro } =
                                response;

                            if (!erro) {
                                setCodeIbge(ibge);
                                setUfLocation(uf);
                                setCepDigitado(cep.replace(/\D/g, ''));
                                BuscarCodIbge(ibge);
                                setBairro(
                                    lastContract.Bairro.length > 1 ?
                                        lastContract.Bairro.toUpperCase() :
                                        bairro ?
                                            bairro.toUpperCase() :
                                            ''
                                );
                                setResidencia(
                                    lastContract.Residencia.length > 1 ?
                                        lastContract.Residencia.toUpperCase() :
                                        logradouro ?
                                            logradouro.toUpperCase() :
                                            ''
                                );
                                setLocalidade(
                                    localidade ? localidade.toUpperCase() : ''
                                );
                                setEstado(uf);
                                setBuscaCep(false);
                            }
                        })
                        .catch(erro => {
                            console.log('error', erro);
                            setBuscaCep(false);
                            setCepDigitado(cep);
                        });
                }
            } else if (cep === 'AT') {
                setSubGrupos([
                    {
                        label: 'ZELO PRIME 4 ANOS',
                        value: 'ZP4'
                    }
                ]);
            } else if (cep === 'A') {
                setSubGrupos([
                    {
                        label: 'ZELO PRIME ANUAL',
                        value: 'ZPA'
                    }
                ]);
            } else {
                await BuscarProdutos();
            }
        } catch (error) {
            showMessageError('ops...', 'erro ao buscar cep!');
        } finally {
            setLoadingProducts(false);
        }
    };

    const showMessageError = (summary, detail) => {
        growl.current.show({
            severity: 'error',
            summary: summary || 'Algo deu errado',
            detail: detail || 'tente novamente!'
        });
    };

    const sleep = milliseconds =>
        new Promise(resolve => setTimeout(resolve, milliseconds));

    const estadosPlanosSupremos = (ufLocation, data, ufElegiveis) => {
        if (!ufElegiveis.includes(ufLocation)) {
            return data.filter(
                planos =>
                    planos.plano.trim().substr(0, 4) !== 'ZS' &&
                    planos.plano.trim().substr(0, 4) !== 'ZSUC'
            );
        } else {
            return data;
        }
    };

    //* Função para localizar o produto por SubGrupo/ Região
    async function getProduct() {
        try {
            await sleep(100);
            setLoadingProducts(true);

            const locationUf = ufLocation === null ? 'MG' : ufLocation;

            const { data } = await getProducts(locationUf, codeIbge, 'Plano');

            const objetosSubGrupoComDescontoBoleto = data.filter(
                objetoSubGrupoComDesconto => objetoSubGrupoComDesconto.descontoBoleto
            );
            const objetosSubGrupoComDescontoCartao = data.filter(
                objetoSubGrupoComDesconto => objetoSubGrupoComDesconto.descontoCartao
            );
            const objetosSubGrupoComDescontoEscelsa = data.filter(
                objetoSubGrupoComDesconto =>
                    objetoSubGrupoComDesconto?.descontoEscelsa
            );

            setSubGruposComDescontoBoleto(
                objetosSubGrupoComDescontoBoleto.map(value => ({
                    plano: value.plano.trim(),
                    dataFinalDesconto: moment(value.descontoBoleto.vigenciaFim).format(
                        'DD/MM/YYYY'
                    ),
                    valorFinal: value.valorBase - value.descontoBoleto.valor,
                    dataInicioDesconto: moment(
                        value.descontoBoleto.vigenciaInicio
                    ).format('DD/MM/YYYY'),
                    tipoPagamento: value.descontoBoleto.tipoCobranca
                }))
            );

            setSubGruposComDescontoCartao(
                objetosSubGrupoComDescontoCartao.map(value => ({
                    plano: value.plano.trim(),
                    dataFinalDesconto: moment(value.descontoCartao.vigenciaFim).format(
                        'DD/MM/YYYY'
                    ),
                    valorFinal: value.valorBase - value.descontoCartao.valor,
                    dataInicioDesconto: moment(
                        value.descontoCartao.vigenciaInicio
                    ).format('DD/MM/YYYY'),
                    tipoPagamento: value.descontoCartao.tipoCobranca
                }))
            );

            setSubGruposComDescontoEscelsa(
                objetosSubGrupoComDescontoEscelsa.map(value => ({
                    plano: value.plano.trim(),
                    dataFinalDesconto: moment(value.descontoEscelsa.vigenciaFim).format(
                        'DD/MM/YYYY'
                    ),
                    valorFinal: value.valorBase - value.descontoEscelsa.valor,
                    dataInicioDesconto: moment(
                        value.descontoEscelsa.vigenciaInicio
                    ).format('DD/MM/YYYY'),
                    tipoPagamento: value.descontoEscelsa.tipoCobranca
                }))
            );

            if (data) {
                data.forEach(element => {
                    element.label = element.Produto.descricao;
                    element.value = element.plano;
                });

                if (codeIbge === '3134608' && tipoVenda !== 'TROCA') {
                    const subGrupoZSM = ['ZSM', 'ZSMC', 'ZSMT', 'ZSMTC'];

                    const subGrupos = {
                        filtrarSubGrupoSobMedidaJaboticatubas() {
                            return data
                                .filter(item => !subGrupoZSM.includes(item.plano.trim()))
                                .map(plano => plano);
                        }
                    };

                    const filtrado = subGrupos.filtrarSubGrupoSobMedidaJaboticatubas();

                    setGrupoRegiao(filtrado);
                    setPlanoRegiao(filtrado);

                    return;
                }

                if (area == 6) {
                    let subgrupoCemiterio = [];

                    subgrupoCemiterio = data.filter(
                        item => item.plano.trim().substr(0, 2) == 'ZI'
                    );

                    const subGrupoPet = data.filter(
                        item => item.plano.trim() == 'ZPET'
                    );

                    if (subGrupoPet[0]) {
                        subgrupoCemiterio.push(subGrupoPet[0]);
                    }

                    setGrupoRegiao(subgrupoCemiterio);
                    setPlanoRegiao(data);
                } else if (area == 3) {
                    const subGrupoPrime = data.filter(
                        item =>
                            item.plano.trim().substr(0, 2) === 'ZP' &&
                            item.plano.trim().substr(0, 4) !== 'ZPET'
                    );

                    setGrupoRegiao(subGrupoPrime);
                    setPlanoRegiao(data);
                } else if (area == 7) {
                    const subGruposAreaSete = [
                        'ZF',
                        'ZT',
                        'ZI',
                        'ZS',
                        'ZTC',
                        'ZFC',
                        'ZT65',
                        'ZTC65',
                        'ZSUC',
                        'ZPET'
                    ];

                    const subGrupos = {
                        filtrarSubGruposAreaSete() {
                            return data
                                .filter(item =>
                                    subGruposAreaSete.includes(item.plano.trim())
                                )
                                .map(plano => plano);
                        }
                    };

                    setGrupoRegiao(subGrupos.filtrarSubGruposAreaSete());

                    setPlanoRegiao(data);
                } else if (area == 1) {
                    if (opCidadesZPETNExterno.includes(codeIbge)) {
                        setGrupoRegiao(data);
                        setPlanoRegiao(data);
                    } else {
                        const filtroZPETNExterno = data.filter(subGrupo => subGrupo.plano.trim() !== 'ZPETN');

                        setGrupoRegiao(filtroZPETNExterno);
                        setPlanoRegiao(data);
                    }
                } else {
                    let subgrupoAll = data.filter(
                        item => item.plano.trim().substr(0, 2) !== 'ZP'
                    );

                    const subGrupoPet = data.filter(
                        item => item.plano.trim() == 'ZPET'
                    );
                    const subGrupoPetNacional = data.filter(
                        item => item.plano.trim() == 'ZPETN'
                    );

                    if (area == 2) {
                        const objQuery = {
                            valorCpf: valorCpf
                                .replace('.', '')
                                .replace('-', '')
                                .replace('.', ''),
                            nome: valorNome
                        };

                        const query = auxQueryParamsRotaMailing(objQuery);
                        let clienteMailing = {};

                        if (valorNome?.length >= 10 || valorCpf.length >= 14) {
                            clienteMailing =
                                await mailingService.verificarClienteMailing(query);
                        }

                        if (clienteMailing.status === 'error' || !clienteMailing.data) {
                            subgrupoAll = subgrupoAll.filter(
                                item => item.plano.trim() !== 'ZCO'
                            );
                        }

                        subGrupoPetNacional.length > 0 &&
                            subgrupoAll.push(subGrupoPetNacional[0]);
                    }

                    subGrupoPet.length > 0 && subgrupoAll.push(subGrupoPet[0]);

                    subgrupoAll = estadosPlanosSupremos(ufLocation, subgrupoAll, [
                        'MG',
                        'CE',
                        'TO'
                    ]);
                    setGrupoRegiao(subgrupoAll);
                    setPlanoRegiao(data);
                }
            }
        } catch (error) {
            showMessageError('ops...', 'erro ao buscar sub grupos!');
        } finally {
            setLoadingProducts(false);
        }
    }

    useEffect(() => {
        if (CepDigitado.length >= 8) {
            getProduct();
        }
    }, [ufLocation, CepDigitado, tipoVenda]);

    const BuscarCodIbge = codIbge => {
        BuscarCidadeIbge(codIbge)
            .then(response => {
                if (response) {
                    setCidade(response.data.Codigo);
                }
            })
            .catch(error => {
                throw new Error(error);
            });
    };

    const changeCidade = e => {
        setLocalidade(e.target.value);
        BuscarCodIbge(e.target.value);
    };

    const buscarCPF = cpf => {
        if (cpfCadastrado != cpf) {
            setLoadingProducts(true);
            api.get(`/associados/cpf/${cpf}`)
                .then(resp => {
                    setLoadingProducts(false);
                    setSubmit(false);
                    setCpfCadastrado(cpf);

                    if (resp.data.state == 200) {
                        setDisplayBasic(true);

                        const listItem = resp.data.resultado;

                        const lastContractData = listItem.reduce((prev, current) =>
                            prev.Inscricao > current.Inscricao ? prev : current
                        );

                        setBairro('');
                        setResidencia('');
                        setLocalidade('');

                        setLastContract(lastContractData);

                        for (const i in listItem) {
                            const atualItem = listItem[i];
                            const respSub = subGrupos.find(
                                conteudo => conteudo.SubGrupo == atualItem.SubGrupo
                            );

                            listItem[i].descSubGrupo =
                                respSub === undefined ?
                                    atualItem.SubGrupo :
                                    respSub.descricao;
                        }

                        setobjFinal(listItem);
                    }
                })
                .catch(err => {
                    setLoadingProducts(false);
                    setSubmit(false);

                    return err;
                });
        }
    };

    yup.addMethod(yup.string, 'cpf', args => {
        const { message } = args;

        return yup.mixed().test('cpf', message, function (value) {
            const { path, createError } = this;
            const message = 'CPF inválido';

            const cpfDigitado = value;

            if (value !== undefined) {
                if (validarCpfSemMascara(value) === true) {
                    value = true;
                    setCpfCadastrado(cpfDigitado);
                    buscarCPF(cpfDigitado);
                } else {
                    value = false;
                }
            } else {
                value = false;
            }

            return (
                value ||
                createError({
                    path,
                    message
                })
            );
        });
    });

    const initialValues = {
        Nome: importLastContract ? (lastContract.Nome ? lastContract.Nome : '') : '',
        CPF: cpfCadastrado,
        RG: importLastContract ? (lastContract.RG ? lastContract.RG : '') : '',
        Nascimento: importLastContract ?
            lastContract.Nascimento ?
                new Date(lastContract.Nascimento) :
                '' :
            '',
        Sexo: importLastContract ? (lastContract.Sexo ? lastContract.Sexo : '') : '',

        CEPResid: importLastContract ?
            lastContract.CEPResid ?
                lastContract.CEPResid :
                '' :
            '',
        numeroResidencia: importLastContract ?
            lastContract.numeroResidencia ?
                lastContract.numeroResidencia :
                '' :
            '',
        Complemento: importLastContract ?
            lastContract.Complemento ?
                lastContract.Complemento :
                '' :
            '',
        AssReferenciaEndereco: importLastContract ?
            lastContract.AssReferenciaEndereco ?
                lastContract.AssReferenciaEndereco :
                '' :
            '',
        Telefone: importLastContract ?
            lastContract.Telefone ?
                lastContract.Telefone :
                '' :
            '',
        Celular: importLastContract ?
            lastContract.Celular ?
                lastContract.Celular :
                '' :
            '',

        MaeAssoc: importLastContract ?
            lastContract.MaeAssoc ?
                lastContract.MaeAssoc :
                '' :
            '',
        PaiAssoc: importLastContract ?
            lastContract.PaiAssoc ?
                lastContract.PaiAssoc :
                '' :
            '',
        AssEmail: importLastContract ?
            lastContract.AssEmail ?
                lastContract.AssEmail :
                '' :
            '',

        DiaVenc,
        SubGrupo: 'Selecione um sub grupo',
        idCemiterio: 0,
        payzentipomensalidade: '',
        AssTipoCobranca: '',
        TipoVenda: '',
        Promocional: false,
        Carencia: 0,
        DescricaoCarencia: '',
        Obs1: '',
        Origem: 'Portal-vendas',
        unidade_trabalho_vendedor: idLocation,
        filialVendedor: '',
        vencimentoFatura: '',
        ValorDinamico: ''
    };

    const planoPorRegiao = (subgrupo, value) => {
        for (const regiao of value) {
            if (subgrupo === regiao.plano) {
                const { id } = regiao;

                return id;
            }
        }
    };

    const cemiterioEstadoZS = cemiterios => {
        const cidadeCodigo = {
            MG: '31',
            TO: '17',
            CE: '23'
        };

        return cemiterios.filter(
            cemiterio =>
                String(cemiterio.codIBGE).trim().substr(0, 2) ==
                cidadeCodigo[ufLocation]
        );
    };

    const handleBuscaCemiterio = async subGrupo => {
        setSubgrupoSelecionado(subGrupo);

        let cemiterios = await buscaNomeCemiterio(subGrupo);

        cemiterios = cemiterioEstadoZS(cemiterios);

        setNomeCemiterio(
            cemiterios.map(value => ({
                label: value.cemiterio,
                value: value.id
            }))
        );
    };

    const salvarValorDinamico = async dadosBody => {
        await SalvarValorDinamicoAssoc(dadosBody);
    };

    const handleSubmit = async values => {
        setLoadingProducts(true);

        const diasCarencia = opCarencia.find(option => option.value === values.Carencia);
        const valorBase = await planoPorRegiao(values.SubGrupo, planoRegiao);
        const valorDinamico = String(values.ValorDinamico);

        if (values.SubGrupo.trim() === 'ZS' || values.SubGrupo.trim() === 'ZSUC') {
            if (
                ufLocation.trim() === 'CE' ||
                ufLocation.trim() === 'MG' ||
                ufLocation.trim() === 'TO'
            ) {
                if (values.idCemiterio === 0) {
                    showMessageAlert(
                        'Cemitério Vazio!',
                        'Favor, selecione um cemitério!'
                    );
                    setSubmit(false);
                    setLoadingProducts(false);
                    setSubmit(false);
                    window.scrollTo(0, 0);
                    setErro(true);

                    return;
                }
            }
        }

        setSubmit(true);

        if (
            values.AssReferenciaEndereco === null ||
            values.AssReferenciaEndereco === undefined ||
            values.AssReferenciaEndereco === ''
        ) {
            values.AssReferenciaEndereco = 'n/a';
        }

        if (values.payzentipomensalidade === 'AT') {
            values.payzentipomensalidade = '4';

            if (values.SubGrupo.trim().substr(0, 3) === 'ZPC') {
                values.SubGrupo = 'ZPC4';
            }

            if (values.SubGrupo.trim().substr(0, 3) === 'ZP4') {
                values.SubGrupo = 'ZP4';
            }
        }

        if (values.payzentipomensalidade === 'A') {
            if (values.SubGrupo.trim().substr(0, 3) === 'ZPC') {
                values.SubGrupo = 'ZPCA';
            }

            if (values.SubGrupo.trim().substr(0, 3) === 'ZPA') {
                values.SubGrupo = 'ZPA';
            }
        }

        if (area === 2) {
            const dataFilial = filialVendedor.filter(
                item => item.filial === values.filialVendedor
            );

            values.unidade_trabalho_vendedor = dataFilial[0].id;
        }

        delete values.filialVendedor;

        if (valido) {
            if (codeIbge) {
                BuscarCodIbge(codeIbge);
            }

            values.troca = values.TipoVenda === 'TROCA' ? true : false;

            values.Nome = values.Nome.toUpperCase();
            values.Status = '1';
            values.Complemento =
                values.Complemento == undefined ?
                    'null' :
                    values.Complemento.length < 1 ?
                        'null' :
                        values.Complemento;
            values.Obs1 = values.Promocional ?
                (values.Obs1 === undefined || values.Obs1.length < 1 ?
                    `CARÊNCIA ${diasCarencia.label.toUpperCase()}` :
                    `${values.Obs1.toUpperCase()} CARÊNCIA ${diasCarencia.label.toUpperCase()}`) :
                (values.Obs1 === undefined || values.Obs1.length < 1 ?
                    'null' :
                    values.Obs1.toUpperCase());
            values.Data = moment(new Date()).add(3, 'hours').format('YYYY-MM-DD');
            values.Sexo = values.Sexo || 'Outros';
            values.Grupo = 'PRE';
            values.CEPResid = CepDigitado.replace(/\D/g, '');
            values.CarenAtend = moment(new Date())
                .add(3, 'months')
                .format('YYYY-MM-DD');
            values.CarenFuneral = moment(new Date())
                .add(3, 'months')
                .format('YYYY-MM-DD');
            values.Residencia = Residencia;
            values.Bairro = Bairro;
            values.Cidade = parseInt(Cidade);
            values.Vendedor = Vendedor;
            values.Supervisor = Supervisor || 'NUL';
            values.Coordenador = Coordenador || 'NUL';
            values.Nascimento = moment(values.Nascimento)
                .add(3, 'hours')
                .format('YYYY-MM-DD');
            values.Origem = 'portal-vendas';
            values.valor_base = valorBase;
            delete values.ValorDinamico;

            const dataVencimentoString = (values.vencimentoFatura = moment(
                values.vencimentoFatura
            )
                .add(3, 'hours')
                .format('YYYY-MM-DD'));

            values.vencimentoFatura = parseInt(dataVencimentoString.slice(-2));

            InserirAssociado(values)
                .then(response => {
                    window.scrollTo(0, 0);

                    if (Number.isInteger(response)) {
                        const dadosUltimoContrato = {
                            inscricao: response,
                            tipoVenda: values.TipoVenda,
                            tipoCobranca: values.AssTipoCobranca
                        };

                        criptObjectOnLocalStorage(
                            'dadosUltimoContrato',
                            dadosUltimoContrato
                        );

                        if (
                            values.AssTipoCobranca === 8 ||
                            values.TipoVenda === 'TROCA'
                        ) {
                            if (values.SubGrupo?.trim() === 'ZTA') {
                                salvarValorDinamico({
                                    inscricao: response,
                                    valor: valorDinamico,
                                    subGrupo: values.SubGrupo.trim()
                                });
                            }

                            setTimeout(() => {
                                setLoadingProducts(false);
                                history.push(`/cadastrar-documentos/${response}`);
                            }, 1000);
                        } else {
                            setTimeout(() => {
                                setLoadingProducts(false);
                                history.push(`/cadastrar-documentos/${response}`);
                            }, 1000);
                        }
                    } else if (response.status === 400) {
                        setTimeout(() => {
                            setLoadingProducts(false);
                            setSubmit(false);
                            window.scrollTo(0, 0);
                            setErro(true);
                            setMensagem('Dados em formato incorreto');
                        }, 2000);
                    } else if (response.status === 500) {
                        setTimeout(() => {
                            setLoadingProducts(false);
                            setSubmit(false);
                            window.scrollTo(0, 0);
                            setErro(true);
                            setMensagem('Estamos com problemas no Servidor');
                        }, 2000);
                    } else if (response.error.response.status === 422) {
                        setLoadingProducts(false);
                        setSubmit(false);
                        window.scrollTo(0, 0);
                        setErro(true);

                        const msgRetorno = montarMsgAmigavel(
                            response.error.response.data.details[0].message
                        );

                        setMensagem(msgRetorno);
                        window.scrollTo(0, 0);
                    } else {
                        setLoadingProducts(false);
                        setSubmit(false);
                        window.scrollTo(0, 0);
                        setErro(true);
                        setMensagem(
                            'Houve um problema não identificado tente novamente mais tarde'
                        );
                    }
                })
                .catch(() => {
                    setLoadingProducts(false);
                    setSubmit(false);
                    window.scrollTo(0, 0);
                    setErro(true);
                    setMensagem(
                        'Houve um problema não identificado tente novamente mais tarde'
                    );
                });
        } else {
            setLoadingProducts(false);
            setSubmit(false);
            window.scrollTo(0, 0);
            setErro(true);
            setMensagem('Ops Algo deu errado');
        }
    };

    const header = <img alt="Card" src={FundoAmarelo} />;

    const [activeIndex] = useState(0);

    const changeResidencia = e => {
        setResidencia(e.target.value);
    };

    const changeBairro = e => {
        setBairro(e.target.value);
    };

    const onHide = stateMethod => {
        stateMethod(false);
    };

    const getDateLastContract = () => {
        setLoading('nada');
        setSubmit(true);
        setImportLastContract(true);
        onHide(setDisplayBasic);
        lastContract.CEPResid && CEP(lastContract.CEPResid, 2);

        setTimeout(() => {
            setLoading('loading');
            setSubmit(false);
            setModalCopiarDadosContrato(true);
        }, 1000);
    };

    const clenAndNewContract = () => {
        setLoading('nada');
        setSubmit(true);
        setImportLastContract(false);
        onHide(setDisplayBasic);

        setTimeout(() => {
            setLoading('loading');
            setSubmit(false);
        }, 500);
    };

    function handleChangeMask(event) {
        const { value } = event.target;

        setValorCpf(mascaraCpf(value));
    }

    const dropdownComTooltip = option => (
        <div>
            <div
                className="tooltip"
                data-tooltip={new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(option.valorBase)}
            >
                {option.label}
            </div>
        </div>
    );

    const footer = (
        <div className="container-footer">
            <span className="footer-item">
                Deseja copiar os dados do último contrato encontrado?
            </span>
            <Button
                label="Sim, quero copiar os dados"
                icon="pi pi-copy"
                iconPos="left"
                className="footer-item"
                onClick={getDateLastContract}
            />
            <Button
                label="Não, começar novo cadastro"
                icon="pi pi-file"
                iconPos="left"
                className="p-button p-ml-3 gray-button"
                onClick={clenAndNewContract}
            />
        </div>
    );

    const mensagemSubGrupoComDesconto = useCallback(
        values => {
            const formaPagamento = values.AssTipoCobranca;
            let subGrupoComDesconto;
            const dataHoje = moment().format('DD/MM/YYYY');

            switch (formaPagamento) {
                case 1:
                    subGrupoComDesconto = subGruposComDescontoBoleto.find(
                        subgrupo =>
                            subgrupo.plano === values.SubGrupo.trim() &&
                            subgrupo.tipoPagamento === values.AssTipoCobranca &&
                            subgrupo.dataFinalDesconto >= dataHoje
                    );
                    break;
                case 7:
                    subGrupoComDesconto = subGruposComDescontoCartao.find(
                        subgrupo =>
                            subgrupo.plano === values.SubGrupo.trim() &&
                            subgrupo.tipoPagamento === values.AssTipoCobranca &&
                            subgrupo.dataFinalDesconto >= dataHoje
                    );
                    break;
                case 8:
                    subGrupoComDesconto = subGruposComDescontoEscelsa.find(
                        subgrupo =>
                            subgrupo.plano === values.SubGrupo.trim() &&
                            subgrupo.tipoPagamento === values.AssTipoCobranca &&
                            subgrupo.dataFinalDesconto >= dataHoje
                    );
            }

            const valorFinalString = subGrupoComDesconto ?
                new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(subGrupoComDesconto.valorFinal) :
                '';

            return (
                subGrupoComDesconto && (
                    <div style={{ margin: '8px 0' }}>
                        <Message
                            severity="warn"
                            text={`A mensalidade do plano para esta forma de pagamento está com o valor promocional de ${valorFinalString}.
            Promoção vigente entre o período de ${subGrupoComDesconto.dataInicioDesconto} até ${subGrupoComDesconto.dataFinalDesconto}.`}
                        ></Message>
                    </div>
                )
            );
        },
        [
            subGruposComDescontoBoleto,
            subGruposComDescontoCartao,
            subGruposComDescontoEscelsa
        ]
    );

    const formatarData = data => (
        moment(data).utc(true).add(3, 'hours').format('DD/MM/YYYY')
    );

    useEffect(() => {
        (async () => {
            if (subgrupoSelecionado && codeIbge) {
                try {
                    const existeBonificacao = await BuscarProdutoBonificaco(subgrupoSelecionado.trim(), codeIbge);

                    if (existeBonificacao && existeBonificacao.tiposCobrancaIds.includes(isTipoCobrancaSelecionado)) {
                        const porcentagemDesconto = existeBonificacao?.porcentagemDesconto;
                        const tipoMsgPromocional = porcentagemDesconto ?
                            `e receberá um desconto de ${porcentagemDesconto}% nas parcelas ${existeBonificacao.parcelaBonificacao}` :
                            `e as parcelas ${existeBonificacao.parcelaBonificacao} serão abonadas`;

                        const textoMsg = `No período de ${formatarData(existeBonificacao.datasVigencia.inicio)} até ${formatarData(existeBonificacao.datasVigencia.final)}, 
                           a forma de pagamento selecionada está com uma promoção vigente, ${tipoMsgPromocional}.`;

                        setMsgPlanosParaBonificar(
                            <div style={{ margin: '8px 0' }}>
                                <Message
                                    severity="warn"
                                    text={textoMsg}
                                ></Message>
                            </div>
                        );
                    } else {
                        setMsgPlanosParaBonificar(null);
                    }
                } catch (error) {
                    console.error('Erro ao buscar bonificação', error);
                }
            }
        })();
    }, [subgrupoSelecionado, isTipoCobrancaSelecionado]);

    return (
        <Card className="tratar-scroll-card" header={header} title="Cadastrar Contrato">
            <Growl ref={growl} />
            <Dialog
                style={{
                    width: '80%',
                    height: '560px'
                }}
                header={`CPF Já cadastrado "${cpfCadastrado}":`}
                visible={displayBasic}
                onHide={() => onHide(setDisplayBasic)}
                footer={footer}
                closable={false}
            >
                <Card>
                    <PopupCpf objFinal={objFinal} />
                </Card>
            </Dialog>

            <DialogCopiarDadosContrato
                openModal={modalCopiarDadosContrato}
                closeModal={() => setModalCopiarDadosContrato(false)}
            />

            <div className={loading}>
                <ProgressSpinner
                    style={{
                        width: '300px',
                        height: '150px',
                        display: 'flex',
                        margin: '0 auto',
                        marginTop: '8%'
                    }}
                    strokeWidth="1"
                    fill="#EEEEEE"
                    animationDuration=".5s"
                />
            </div>

            <Dialog
                visible={loadingProducts}
                onHide={() => setLoadingProducts(false)}
                closable={false}
            >
                <Card className="tratar-scroll-card">
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            margin: '0 auto',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </Card>
            </Dialog>
            {submit === false && (
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validations}
                >
                    {({ handleChange, values, setFieldValue }) => {
                        if (cepInvalido) {
                            values.CEPResid = '';
                            setCepInvalido(false);
                        }

                        setTipoVenda(values.TipoVenda);

                        return (
                            <FormFormik className="p-col-12  p-lg-12 p-sm-12">
                                {values.TipoVenda === 'TROCA' ||
                                    values.AssTipoCobranca === 8 ? (
                                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                        <Steps
                                            model={itemsDocumento}
                                            activeIndex={activeIndex}
                                        />
                                    </div>
                                ) : (
                                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                        <Steps
                                            model={itemsDocumento}
                                            activeIndex={activeIndex}
                                        />
                                    </div>
                                )}
                                {erro && (
                                    <div className="p-col-12  p-lg-12 p-sm-12">
                                        <Message severity="error" text={mensagem} />
                                    </div>
                                )}
                                <Fieldset legend="Dados Cliente">
                                    <div className="p-grid p-fluid ">
                                        <div className="p-col-12 p-md-8">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                value={
                                                    values.Nome ?
                                                        values.Nome.toUpperCase() :
                                                        values.Nome
                                                }
                                                as={InputText}
                                                onChange={e => {
                                                    handleChange(e);
                                                    setValorNome(e.target.value);
                                                }}
                                                onBlur={() => {
                                                    if (
                                                        CepDigitado.length >= 8 &&
                                                        values.Nome?.length >= 10 &&
                                                        values.Nome?.toUpperCase() !==
                                                        valorNomeAnterior?.toUpperCase()
                                                    ) {
                                                        getProduct();
                                                        setFieldValue('SubGrupo', '');
                                                    }

                                                    setValorNomeAnterior(values.Nome);
                                                }}
                                                name="Nome"
                                                type="text"
                                                id="Nome"
                                                placeholder="Nome"
                                                maxlength="50"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Nome"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            &nbsp;
                                            <Field
                                                value={values.DiaVenc}
                                                placeholder="Dia Vencimento"
                                                name="DiaVenc"
                                                onChange={handleChange}
                                                id="DiaVenc"
                                                as={InputText}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="DiaVenc"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="p-grid p-fluid ">
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                as={InputText}
                                                name="CPF"
                                                id="CPF"
                                                autoClear={false}
                                                maxlength="14"
                                                placeholder="CPF"
                                                onChange={e => {
                                                    handleChange(e);
                                                    handleChangeMask(e);
                                                }}
                                                onBlur={() => {
                                                    if (
                                                        CepDigitado.length >= 8 &&
                                                        valorCpf.length >= 14 &&
                                                        valorCpf !== valorCpfAnterior
                                                    ) {
                                                        getProduct();
                                                        setFieldValue('SubGrupo', '');
                                                    }

                                                    setValorCpfAnterior(valorCpf);
                                                }}
                                                value={valorCpf}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="CPF"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            &nbsp;
                                            <Field
                                                as={InputText}
                                                placeholder="RG"
                                                name="RG"
                                                onChange={handleChange}
                                                id="RG"
                                                maxlength="14"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="RG"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            &nbsp;
                                            <Field
                                                value={`Data: ${Data}`}
                                                placeholder="Data"
                                                onChange={handleChange}
                                                name="Data"
                                                id="Data"
                                                as={InputText}
                                                dateFormat="dd/mm/yy"
                                                disabled="true"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Data"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid ">
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                value={values.Nascimento}
                                                placeholder="Nascimento"
                                                name="Nascimento"
                                                id="Nascimento"
                                                as={Calendar}
                                                locale={ptBR}
                                                onChange={e => {
                                                    handleChange(e);
                                                    handleNascimento(e);
                                                }}
                                                monthNavigator
                                                dateFormat="dd/mm/yy"
                                                yearNavigator
                                                yearRange="1900:2030"
                                            />
                                            <ErrorMessage
                                                locale={ptBR}
                                                component="span"
                                                name="Nascimento"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                as={Dropdown}
                                                value={values.Sexo || 'Outros'}
                                                name="Sexo"
                                                id="Sexo"
                                                onChange={handleChange}
                                                options={opSexo}
                                                placeholder="Selecione o sexo"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Sexo"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            &nbsp;
                                            <Field
                                                type="selectlist"
                                                as={InputText}
                                                value="Portal"
                                                name="Grupo"
                                                onChange={handleChange}
                                                id="Grupo"
                                                placeholder="Grupo"
                                                disabled="true"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Grupo"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>
                                </Fieldset>
                                <br />

                                <Fieldset legend="Endereço">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon
                                                        icon={faAddressBook}
                                                    />
                                                </span>
                                                <Field
                                                    value={values.CEPResid}
                                                    placeholder="CEP"
                                                    name="CEPResid"
                                                    as={InputText}
                                                    maxlength="10"
                                                    onChange={handleChange}
                                                    onBlur={() => {
                                                        CEP(values.CEPResid, 1);
                                                        values.SubGrupo =
                                                            initialValues.SubGrupo;
                                                    }}
                                                />
                                                {buscaCep === true && (
                                                    <span className="p-inputgroup-addon">
                                                        <ProgressSpinner
                                                            style={{
                                                                width: '16px',
                                                                height: '16px'
                                                            }}
                                                            strokeWidth="1"
                                                            fill="#EEEEEE"
                                                            animationDuration=".5s"
                                                        />
                                                    </span>
                                                )}
                                            </div>
                                            <ErrorMessage
                                                component="span"
                                                name="CEPResid"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-8">
                                            &nbsp;
                                            <Field
                                                as={InputText}
                                                value={Residencia}
                                                name="Residencia"
                                                id="Residencia"
                                                placeholder="Rua/Av"
                                                maxlength="50"
                                                onChange={e => {
                                                    changeResidencia(e);
                                                }}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Residencia"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-3">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                as={InputText}
                                                value={values.numeroResidencia}
                                                name="numeroResidencia"
                                                id="numeroResidencia"
                                                placeholder="Número"
                                                onChange={handleChange}
                                                maxlength="10"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="numeroResidencia"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            &nbsp;
                                            <Field
                                                as={InputText}
                                                value={
                                                    values.Complemento ?
                                                        values.Complemento.toUpperCase() :
                                                        values.Complemento
                                                }
                                                name="Complemento"
                                                id="Complemento"
                                                placeholder="Complemento"
                                                maxlength="50"
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            &nbsp;
                                            <Field
                                                as={InputText}
                                                value={
                                                    values.AssReferenciaEndereco ?
                                                        values.AssReferenciaEndereco.toUpperCase() :
                                                        values.AssReferenciaEndereco
                                                }
                                                name="AssReferenciaEndereco"
                                                id="AssReferenciaEndereco"
                                                placeholder="Referência"
                                                maxlength="70"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="AssReferenciaEndereco"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            &nbsp;
                                            <Field
                                                as={InputText}
                                                value={Bairro}
                                                name="Bairro"
                                                id="Bairro"
                                                placeholder="Bairro"
                                                maxlength="50"
                                                onChange={e => {
                                                    changeBairro(e);
                                                }}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="Bairro"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-8">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <i className="pi pi-map-marker" />
                                                </span>
                                                <Field
                                                    as={InputText}
                                                    value={Localidade}
                                                    name="Localidade"
                                                    id="Localidade"
                                                    placeholder="Cidade"
                                                    onChange={e => {
                                                        changeCidade(e);
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="span"
                                                    name="Localidade"
                                                    style={{ color: 'red' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <i className="pi pi-globe" />
                                                </span>
                                                <Field
                                                    as={InputText}
                                                    value={Estado}
                                                    name="Estado"
                                                    id="Estado"
                                                    placeholder="Estado"
                                                    maxlength="25"
                                                    onChange={e => {
                                                        setEstado(e.value);
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="span"
                                                    name="Estado"
                                                    style={{ color: 'red' }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-6">
                                            &nbsp;
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon icon={faPhone} />
                                                </span>
                                                <Field
                                                    as={InputMask}
                                                    placeholder="Telefone"
                                                    name="Telefone"
                                                    onChange={handleChange}
                                                    mask="(99) 9999-9999"
                                                />
                                            </div>
                                            <ErrorMessage
                                                component="span"
                                                name="Telefone"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon icon={faMobile} />
                                                </span>
                                                <Field
                                                    autoClear={false}
                                                    as={InputMask}
                                                    value={values.Celular}
                                                    name="Celular"
                                                    id="Celular"
                                                    onChange={e => {
                                                        handleChange(e);
                                                        checarCelular(e);
                                                    }}
                                                    mask="(99) 99999-9999"
                                                    placeholder="Celular"
                                                />
                                            </div>
                                            <ErrorMessage
                                                component="span"
                                                name="Celular"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Vendedor"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Vendedor"
                                                    disabled
                                                    name="NomeVendedor"
                                                    id="NomeVendedor"
                                                    value={NomeVendedor}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Supervisor"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Supervisor"
                                                    disabled
                                                    name="NomeSupervisor"
                                                    id="NomeSupervisor"
                                                    value={NomeSupervisor}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Coordenador"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Coordenador"
                                                    disabled
                                                    name="NomeCoordenador"
                                                    id="NomeCoordenador"
                                                    value={NomeCoordenador}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                                <br />

                                <Fieldset legend="Dados do Contrato">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                as={Dropdown}
                                                value={values.TipoVenda}
                                                name="TipoVenda"
                                                id="TipoVenda"
                                                onChange={handleChange}
                                                options={opTipoVenda}
                                                placeholder="Tipo Venda"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="TipoVenda"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <Field
                                                value={values.payzentipomensalidade}
                                                as={Dropdown}
                                                options={
                                                    area === '3' ?
                                                        opMensalidadePrime :
                                                        opMensalidade
                                                }
                                                onChange={handleChange}
                                                placeholder="Tipo mensalidade"
                                                name="payzentipomensalidade"
                                                id="payzentipomensalidade"
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="payzentipomensalidade"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            {nascimento >= 65 ? (
                                                <>
                                                    <Field
                                                        as={Dropdown}
                                                        onChange={e => {
                                                            handleChange(e);
                                                            handleBuscaCemiterio(
                                                                e.target.value
                                                            );
                                                        }}
                                                        value={values.SubGrupo}
                                                        name="SubGrupo"
                                                        id="SubGrupo"
                                                        options={condicaoPlanotipoMensalidade(
                                                            grupoRegiao,
                                                            values.payzentipomensalidade,
                                                            values
                                                        )}
                                                        placeholder="Sub Grupo"
                                                    />
                                                    <ErrorMessage
                                                        component="span"
                                                        name="SubGrupo"
                                                        style={{ color: 'red' }}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <Field
                                                        as={Dropdown}
                                                        onChange={e => {
                                                            handleChange(e);
                                                            handleBuscaCemiterio(
                                                                e.target.value
                                                            );
                                                        }}
                                                        value={values.SubGrupo}
                                                        name="SubGrupo"
                                                        id="SubGrupo"
                                                        options={condicaoPlanotipoMensalidadeM65(
                                                            grupoRegiao,
                                                            values,
                                                            values.payzentipomensalidade
                                                        )}
                                                        itemTemplate={
                                                            dropdownComTooltip
                                                        }
                                                        placeholder="Sub Grupo"
                                                    />
                                                    <ErrorMessage
                                                        component="span"
                                                        name="SubGrupo"
                                                        style={{ color: 'red' }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid ">
                                        <div className="p-col-12 p-md-4" style={{ color: 'red' }}>
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *

                                                {values.AssTipoCobranca === 5 &&
                                                    (<>
                                                        <img src={Itau} alt="Itau" height={16} width={16} />
                                                        <img src={BancoBrasil} alt="Banco do Brasil" height={16} width={16} />
                                                        <img src={Bradesco} alt="Bradesco" height={16} width={16} />
                                                    </>)}

                                            </div>
                                            <TipoCobranca area={area} estado={Estado} setTipoCobrancaSelecionado={setTipoCobrancaSelecionado} />
                                        </div>
                                        {blockInput ? (
                                            <div className="p-col-12 p-md-4">
                                                &nbsp;
                                                <Field
                                                    as={Dropdown}
                                                    value={values.filialVendedor}
                                                    name="filialVendedor"
                                                    id="filialVendedor"
                                                    onChange={handleChange}
                                                    options={filialDropdow}
                                                    placeholder="Grupo Alocação"
                                                />
                                                <ErrorMessage
                                                    component="span"
                                                    name="filialVendedor"
                                                    style={{ color: 'red' }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="p-col-12 p-md-4">
                                                &nbsp;
                                                <Field
                                                    as={InputText}
                                                    value={GrupoAlocation}
                                                    name="GrupoAlocation"
                                                    id="GrupoAlocation"
                                                    onChange={handleChange}
                                                    placeholder="Grupo Alocação"
                                                    disabled={true}
                                                />
                                                <ErrorMessage
                                                    component="span"
                                                    name="GrupoAlocation"
                                                    style={{ color: 'red' }}
                                                />
                                            </div>
                                        )}
                                        {(values.SubGrupo.trim() === 'ZS' ||
                                            values.SubGrupo.trim() === 'ZSUC') && (
                                                <div className="p-col-12 p-md-4">
                                                    <div
                                                        className="required"
                                                        style={{ color: 'red' }}
                                                    >
                                                        *
                                                    </div>
                                                    <Field
                                                        dataKey="id"
                                                        id="idCemiterio"
                                                        as={Dropdown}
                                                        onChange={handleChange}
                                                        value={values.idCemiterio}
                                                        name="idCemiterio"
                                                        options={nomeCemiterio}
                                                        placeholder="Nome cemitério"
                                                    />
                                                    <ErrorMessage
                                                        component="span"
                                                        name="idCemiterio"
                                                        style={{ color: 'red' }}
                                                    />
                                                </div>
                                            )}
                                        {values.SubGrupo.trim() === 'ZTA' &&
                                            values.TipoVenda === 'TROCA' && (
                                                <div className="p-col-12 p-md-4">
                                                    <div
                                                        className="required"
                                                        style={{ color: 'red' }}
                                                    >
                                                        *
                                                    </div>
                                                    <Field
                                                        as={InputNumber}
                                                        id="ValorDinamico"
                                                        name="ValorDinamico"
                                                        currency="BRL"
                                                        locale="pt-BR"
                                                        mode="currency"
                                                        min="-1"
                                                        placeholder="R$"
                                                    />

                                                    <ErrorMessage
                                                        component="span"
                                                        name="ValorDinamico"
                                                        style={{ color: 'red' }}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                    {(values.TipoVenda === 'TROCA' ||
                                        values.AssTipoCobranca === 8) && (
                                            <div style={{ margin: '8px 0' }}>
                                                <Message
                                                    severity="warn"
                                                    text=" Você precisará adicionar os
                                                        documentos nescessários na próxima
                                                        etapa."
                                                ></Message>
                                            </div>
                                        )}
                                    {mensagemSubGrupoComDesconto(values)}

                                    {msgPlanosParaBonificar}

                                </Fieldset>
                                <br />

                                <Fieldset legend="Filiação">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-6">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon icon={faFemale} />
                                                </span>
                                                <Field
                                                    as={InputText}
                                                    placeholder="Mãe"
                                                    name="MaeAssoc"
                                                    maxlength="50"
                                                    onChange={handleChange}
                                                    value={
                                                        values.MaeAssoc ?
                                                            values.MaeAssoc.toUpperCase() :
                                                            values.MaeAssoc
                                                    }
                                                    id="MaeAssoc"
                                                />
                                            </div>
                                            <ErrorMessage
                                                component="span"
                                                name="MaeAssoc"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon icon={faMale} />
                                                </span>
                                                <Field
                                                    as={InputText}
                                                    placeholder="Pai"
                                                    name="PaiAssoc"
                                                    onChange={handleChange}
                                                    maxlength="50"
                                                    value={
                                                        values.PaiAssoc ?
                                                            values.PaiAssoc.toUpperCase() :
                                                            values.PaiAssoc
                                                    }
                                                    id="PaiAssoc"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                                <br />

                                <Fieldset legend="Dados complementares">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="Promocional">
                                                Promocional
                                            </label>
                                            <Field
                                                as={Dropdown}
                                                id="Promocional"
                                                name="Promocional"
                                                options={opPromocional}
                                                onChange={handleChange}
                                                style={{ marginTop: '10px' }}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            <label
                                                htmlFor="Carencia"
                                                style={{
                                                    color:
                                                        values.Promocional === false &&
                                                        '#b3b3b3'
                                                }}
                                            >
                                                Carência
                                            </label>
                                            <Field
                                                as={Dropdown}
                                                id="Carencia"
                                                name="Carencia"
                                                options={
                                                    values.Promocional ?
                                                        opCarencia :
                                                        (values.Carencia = 0)
                                                }
                                                placeholder="Em dias"
                                                disabled={
                                                    values.Promocional ? false : true
                                                }
                                                onChange={handleChange}
                                                style={{ marginTop: '10px' }}
                                            />

                                            <ErrorMessage
                                                component="span"
                                                name="Carencia"
                                                style={{ color: 'red' }}
                                            />
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <label
                                                htmlFor="DescricaoCarencia"
                                                style={{
                                                    color:
                                                        values.Promocional === false &&
                                                        '#b3b3b3'
                                                }}
                                            >
                                                Descrição da Promoção
                                            </label>
                                            <Field
                                                as={InputTextarea}
                                                value={
                                                    values.DescricaoCarencia = ''
                                                }
                                                name="DescricaoCarencia"
                                                maxlength="150"
                                                onChange={handleChange}
                                                id="DescricaoCarencia"
                                                placeholder="Máximo 150 caracteres!"
                                                style={{
                                                    marginTop: '10px',
                                                    resize: 'none'
                                                }}
                                                disabled
                                            />

                                            <ErrorMessage
                                                component="span"
                                                name="DescricaoCarencia"
                                                style={{ color: 'red' }}
                                            />
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <label htmlFor="Obs1">Observação</label>
                                            <Field
                                                as={InputTextarea}
                                                value={values.Obs1}
                                                name="Obs1"
                                                maxlength="20"
                                                onChange={handleChange}
                                                id="Obs1"
                                                placeholder="Observação, Máximo 20 caracteres!"
                                                style={{
                                                    marginTop: '10px',
                                                    resize: 'none'
                                                }}
                                            />
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div
                                                className="required"
                                                style={{ color: 'red' }}
                                            >
                                                *
                                            </div>
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">
                                                    <FontAwesomeIcon
                                                        icon={faEnvelope}
                                                    />
                                                </span>
                                                <Field
                                                    as={InputText}
                                                    value={
                                                        values.AssEmail ?
                                                            values.AssEmail.trim() :
                                                            values.AssEmail
                                                    }
                                                    name="AssEmail"
                                                    id="AssEmail"
                                                    onChange={handleChange}
                                                    placeholder="E-mail"
                                                    maxlength="50"
                                                />
                                            </div>
                                            <ErrorMessage
                                                component="span"
                                                name="AssEmail"
                                                style={{ color: 'red' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Vendedor"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Vendedor"
                                                    disabled
                                                    name="NomeVendedor"
                                                    id="NomeVendedor"
                                                    value={NomeVendedor}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Supervisor"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Supervisor"
                                                    disabled
                                                    name="NomeSupervisor"
                                                    id="NomeSupervisor"
                                                    value={NomeSupervisor}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <Button
                                                    label="Coordenador"
                                                    style={{
                                                        backgroundColor: '#E1E1E1',
                                                        borderColor: 'gray',
                                                        color: 'gray'
                                                    }}
                                                    disabled
                                                />
                                                <InputText
                                                    placeholder="Coordenador"
                                                    disabled
                                                    name="NomeCoordenador"
                                                    id="NomeCoordenador"
                                                    value={NomeCoordenador}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                                <br />

                                <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                                    {/* TODO Adicionar load para evitar submeter varias vezer a request */}
                                    <Button
                                        type="submit"
                                        iconPos="left"
                                        className="btn-primary"
                                        label="Cadastrar"
                                    />
                                </div>
                            </FormFormik>
                        );
                    }}
                </Formik>
            )}
            <DialogErroBlacklistCadastrar
                visible={dialogBlacklist}
                openDialog={dialogBlacklist}
                messageHeader="Telefone suspeito!"
                closeDialog={() => setDialogBlacklist(false)}
            />
        </Card>
    );
};

export default CadastrarContratos;
